import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = false;

export const sideMenuSlice = createSlice({
  name: 'sideMenu',
  initialState,
  reducers: {
    openSideMenu: () => true,
    closeSideMenu: () => false,
  },
});

// Action creators are generated for each case reducer function
export const { openSideMenu, closeSideMenu } = sideMenuSlice.actions;

export const getSideMenuState = (state: RootState) => state.sideMenu;

export default sideMenuSlice.reducer;
